<template>
    <v-row>
        <v-col :cols="mapClass">
            <h2 class="custom-title" v-if="custom_title === undefined && nosearch === undefined">Search and add a pin</h2>
            <h2 class="custom-title" v-else>{{custom_title}}</h2>
            <label v-if="nosearch === undefined || nosearch === false">
                <div class="autocomplete-field">
                    <gmap-autocomplete  :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress' 
                    || userRoleId==5
                "
                        @place_changed="setPlace"
                        style="width:100%"
                    >
                    </gmap-autocomplete>
                </div>
            </label>
            <div v-if="center">
            <GmapMap
             :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress' 
                 || userRoleId==5"
                :center="center"
                :zoom="zoom"
                map-type-id="roadmap"
                style="width: 100%; height: 550px"
                :options="options"
                @click="mapClick"
                >
                <gmap-polygon :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                    v-for="(poly,index) in polygonsList" 
                    :paths="poly.coordinates" 
                    :key="`polygon_${index}`" 
                    :editable="true"
                    @paths_changed="updateEdited($event,index)"
                    @click="showDescPolygon($event, poly.desc)" 
                    :options="{
                        fillColor: poly.fillColor,
                        fillOpacity: poly.fillOpacity,
                        strokeOpacity: 0.8,
                        strokeWeight: 1
                        }"
                    ref="polygon">
                </gmap-polygon> 
                <gmap-polyline :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                    v-bind:path.sync="polyLines" 
                    v-bind:options="{ strokeColor:lineStrokeColor }"
                    v-bind:clickable="true"
                    v-on:click="lineClicked()"
                    v-if="drag==false"
                >
                </gmap-polyline>
                <div v-if="showMarkers">
                    <div v-if="has_many_stations">
                        <gmap-marker :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                            v-for="(item, index) in markers"
                            :key="`marker_${index}`"
                            :position="(has_many_stations)? item.coordinate:item.coordinate"
                            :clickable="true"
                            :draggable="true"
                            :icon="markerIcon"
                            @click="openInfoWindowTemplate(item)"
                            @drag="pinDragged($event.latLng, index)"
                            @dragend="drag=false"
                        >
                        </gmap-marker>
                    </div>
                    <div v-else>
                        <gmap-marker v-if="entity !== undefined"
                        :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                 "
                            :position="entity.coordinate"
                            :clickable="true"
                            :draggable="true"
                            :icon="markerIcon"
                            @click="openInfoWindowTemplate(item)"
                            @drag="pinDragged($event.latLng, 0)"
                            @dragend="drag=false"
                        >
                        </gmap-marker>
                    </div>
                </div>
                
                <div v-if="realtime_tracking !== undefined && realtime_tracking === true">
                    <div v-for="(driver, index) in allDrivers" :key="`driver_${index}`">
                        <gmap-marker
                        :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                            :position="driver.coordinate"
                            :clickable="true"
                            :draggable="false"
                            :icon="driverMarkerIcon"
                            @click="openInfoWindowTemplate(driver)"
                        >
                        </gmap-marker>
                        <gmap-info-window
                        :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                            :options="{maxWidth: 300}"
                            :position="driver.coordinate"
                            :opened="driver.info !==undefined && driver.info.infoWindowOpen"
                        >
                            <div v-html="driverTrackingInfo(driver)"></div>
                        </gmap-info-window>
                    </div>
                </div>
                <div v-if="simulatedDriver !== undefined && simulatedDriver.coordinate !== undefined">
                    <gmap-marker
                        :key="`simdriver_1`"
                        :position="simulatedDriver.coordinate"
                        :clickable="true"
                        :draggable="false"
                        :icon="simDriverMarkerIcon"
                        @click="clickDriver( simulatedDriver )"
                    >
                    </gmap-marker>
                    <gmap-polyline 
                        v-bind:path.sync="simulatedLinePoints" 
                        v-bind:options="{ strokeColor:lineStrokeColor }"
                        v-bind:clickable="true"
                        v-on:click="lineClicked()"
                        v-if="drag==false"
                    >
                    </gmap-polyline>
                    <gmap-info-window
                        :options="{maxWidth: 300}"
                        :position="simulatedDriver.coordinate"
                        :opened="simulatedDriver.info !==undefined && simulatedDriver.info.infoWindowOpen"
                    >
                        <div v-html="driverTrackingInfo(simulatedDriver)"></div>
                    </gmap-info-window>
                </div>
                <div v-if="driverStops !== undefined">
                        <gmap-marker
                            v-for="(item, index) in driverStops"
                            :key="`drstops_${index}`"
                            :position="item.coordinate"
                            :clickable="false"
                            :icon="markerIcon"
                            @dragend="drag=false"
                        >
                        </gmap-marker>
                </div>
                <GmapCircle
                    v-for="(pin, index) in new_geofence.coordinates"
                    :key="index + '_newgeofence'"
                    :center="pin"
                    :radius="1000"
                    :visible="true"
                    :options="{fillColor:'red',fillOpacity:1.0}"
                ></GmapCircle>
            </GmapMap>
        </div>
        </v-col>
        <v-col cols='4' v-if="has_fencing">
            <v-row>
                <v-col cols='12'>
                    <h2>Select Clients</h2>
                </v-col>
                <v-col cols='12'>
                    <multiselect  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                        v-model="markers"
                        placeholder="Search for client"
                        label="name"
                        track-by="name"
                        :options="entities['deliveryAddress']"
                        :multiple="true"
                        :taggable="false"
                        :hide-selected="true"
                        :class="generateChipStyle('mediumvioletred')"
                        style="background:none !important"
                        return-object
                    >
                    </multiselect>
                </v-col>
                <v-col cols='8'>
                    <h2>GeoFencing</h2>
                </v-col>
                <v-col cols='4'>
                    <v-btn  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                " class='add-geofence' @click="addOrRemoveGeofencing()" color="primary" style="width:100%">{{geofencing_button_text}}</v-btn>
                </v-col>
                <v-col cols='12'>
                    <multiselect  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                "
                        v-model="polygonsList"
                        placeholder="Select existing Geofencing"
                        label="name"
                        track-by="name"
                        :options="entities['geoRegion']"
                        :multiple="true"
                        :taggable="false"
                        :hide-selected="true"
                        :class="generateChipStyle('red')"
                        style="background:none !important"
                        return-object
                    >
                    </multiselect>
                </v-col>
            </v-row>
            <draggable v-model="polygonsList">
                <transition-group>
                    <div class='draggable-div' v-for="(element,index) in polygonsList" :key="element.identifier + 'geofence'">
                        <v-row>
                            <v-col cols='5'>
                                <v-text-field  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                " dense outlined hide-details v-model="element.name"></v-text-field>
                            </v-col>
                            <v-col cols='5'>
                                <v-select  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                " :items="['red','green','blue','orange','yellow','brown','black','white']"
                                label="Color" dense outlined hide-details
                                v-model="element.fillColor"></v-select>
                            </v-col>
                            <v-col cols='2'>
                                <v-btn  :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                " @click="removeGeofencingAt(index)" color='error'>Delete</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </transition-group>
            </draggable>
        </v-col>
        <v-col cols='12' class="client-waybills" v-if="has_many_stations===true">
            <h2>Clients Waybills</h2>
            <p>Drag to re-arrange the order of the Client Waybills</p>
            <draggable :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' 
                " v-model="markers" v-if="drag === false" @end="$emit('setStationsList', markers)">
                <transition-group>
                    <div class='draggable-div station' v-for="(element, index) in markers" :key="element.lat + 'point' + index">
                        <DeliveryAddressWayBill
                            :element="element"
                            :index="index"
                            :selects="stations_selects"
                            @removeDeliveryAddress="removeDeliveryAddress"
                        ></DeliveryAddressWayBill>
                    </div>
                </transition-group>
            </draggable>
        </v-col>
    </v-row>
</template>
<script>
import draggable from "vuedraggable";
import Multiselect from 'vue-multiselect'
import DeliveryAddressWayBill from './map/DeliveryAddressWayBill'  
import {mapState, mapActions} from 'vuex'
export default {
    data(){
        return { 
            userRoleId:localStorage.getItem("UserRoleId"),
            waybillStatus:localStorage.getItem("SelectedwaybillStatus"),
            newGeofenceMarkerIcon:'',
            center : null,
            zoom: 10,
            options : {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false
            },
            places:[],
            currentPlace: null,
            drag : false,
            lineStrokeColor:'#009900',
            infoWindow: {
                coordinate: {lat: 0, lng: 0},
                open: false,
                template: this.simulatedDriver !== undefined ? `${this.simulatedDriver.info.waybillId} <br/> ${this.simulatedDriver.info.dateTime}` : '10:45 A.M'
            },
            geofencing_click:false,
            new_geofence:{
                fillColor:'red',
                fillOpacity:0.2,
                coordinates:[]
            },
            new_delivery_address:{
                deliveryType:"Drop Off",
                name:"New Delivery Address",
                coordinate:{lat:0,lng:0}
            },
            markers:this.stationsList? this.stationsList: [],
            polygonsList: this.polygons? this.polygons:[],
            allDrivers:[],
            simulatedDriver:this.simulated,
            showMarkers:true
        }   
    },
    props: {
        polygons : Array,
        stationsList : Array,
        has_many_stations: Boolean,
        stations_selects : Array,
        has_fencing:Boolean,
        entity:Object,
        realtime_tracking: Boolean,
        custom_title: String,
        simulated:Object,
        simulatedLinePoints:Array,
        driverStops:Array,
        nosearch:Boolean
    },
    components:{draggable, Multiselect, DeliveryAddressWayBill},
    computed: {
        ...mapState('entities',['loading','entities']), 
        ...mapState('users',['loggedIn','user']),
        geofencing_button_text(){
            return this.geofencing_click ? "Done" : "Add"
        },
        polyLines() {
            return (this.markers)?this.markers.map(m=>m.coordinate):[]
        },
        mapClass() {
            return this.has_many_stations? '8':'12'
        },
        markerIcon() {
            return require( "@/assets/red_pin.png" )
        },
        greenMarkerIcon() {
            return require("@/assets/green_pin.png")
        },
        driverMarkerIcon() {
            return require("@/assets/truck-pin.png")
        },
        simDriverMarkerIcon() {
            return require("@/assets/truck-pin-sim.png")
        },
    },
    mounted() {  
         
        this.getEntities('driver')
        this.geolocate()
        this.getEntities('geoRegion')
        //if is realtime tracking, bind the hub method
        if(this.realtime_tracking) {
            this.$driverHub.$on('driverMessageReceived', this.driverMessageReceived);
        }
    },
    watch: {
        simulated: {
            deep: true,
            handler(newValue, oldValue) {
                this.recenterMap();
            }
        }
    },
    methods:{
        ...mapActions('entities',['getEntities']),
        ...mapActions('users',['isAdmin']),
        setPlace(place) {
            this.addDeliveryAddress({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            });

            this.showMarkers = false;

            setTimeout(()=>{
                this.showMarkers = true
            },150);
        },
        recenterMap() {
            if(this.simulated.coordinate != undefined)
                this.center = this.simulated.coordinate;
        },
        addDeliveryAddress(latlng) {
            //post a delivery address package waybill
            var marker = {
                name:'',
                coordinate:latlng,
                deliveryType:'',
                deliveryDate:'',
                packages:[],
                estimatedArrivalTime:"",
                qrCodeMedia:{}
            }
            if(!this.has_many_stations) {
                marker = {
                    name:'',
                    deliveryType:'',
                    coordinate:latlng
                };
            }
            if(this.has_many_stations || this.markers.length === 0) {
                this.markers.push(marker);
                if(!this.has_many_stations) {
                    this.entity.coordinate = marker.coordinate;
                }
            }
            else {
                this.markers[0].coordinate.latitude = marker;
                this.entity.coordinate = marker.coordinate;
            }
            this.currentPlace = null;
            this.$emit("setStationsList", this.markers);
        },
        addMarker() {
            if(this.currentPlace) {
                this.addDeliveryAddress({
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                });
                //this.places.push(this.currentPlace)
            }
        },
        geolocate(){
            if (this.markers != null && this.markers.length > 0) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: this.markers[0].coordinate.lat,
                        lng: this.markers[0].coordinate.lng
                    };
                });
            } else if(this.driverStops !== undefined) {
                this.center = {
                        lat: this.driverStops[0].coordinate.lat,
                        lng: this.driverStops[0].coordinate.lng
                    };
            } else {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });
            }
        },
        updateEdited(mvcArray, polygonoId) {
            let paths = [];
            for (let i = 0; i < mvcArray.getLength(); i++) {
                let path = [];
                for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
                    let point = mvcArray.getAt(i).getAt(j);
                    path.push({lat: point.lat(), lng: point.lng()});
                }
                paths.push(path);
            }
            this.polygonsList[polygonoId].coordinates = paths[0];
            this.$emit('setGeoFence', this.polygonsList);
        },
        showDescPolygon(event, desc) {
            let contentString = desc;
            this.infoWindowPos = event.latLng;
            this.infoContent = contentString;
            this.infoWinOpen = true;
        },
        lineClicked(){
            if(this.lineStrokeColor.includes('99')) this.lineStrokeColor = this.lineStrokeColor.replace('99','ff');
            else this.lineStrokeColor = this.lineStrokeColor.replace('ff','99');
        },
        openInfoWindowTemplate (item) {
            // this.setInfoWindowTemplate(item)
            this.infoWindow.coordinate = item;
            this.infoWindow.open = true;
        },
        pinDragged(event, index) {
            this.drag=true;
            if(this.has_many_stations) {
                this.markers[index].coordinate.lat = event.lat();
                this.markers[index].coordinate.lng = event.lng();
            }
            else {
                this.entity.coordinate.lat = event.lat();
                this.entity.coordinate.lng = event.lng();
            }
            this.$emit('setStationsList', this.markers);
        },
        removePointAt(idx) {
            this.markers.splice(idx, 1);
        },
        removeGeofencingAt(index) {
            this.polygonsList.splice(index,1);
            this.$emit('setGeoFence', this.polygonsList);
        },
        addOrRemoveGeofencing(){
            this.geofencing_click = !this.geofencing_click;
            if(this.geofencing_click == false) {
                //check the path if it contains 3 or more points to form a polygon
                if(this.new_geofence.coordinates.length >= 3) {
                    var id = this.polygonsList.length + 1;
                    var fence = {
                        identifier:`poly_${id}`,
                        fillColor: this.new_geofence.fillColor,
                        fillOpacity: this.new_geofence.fillOpacity,
                        coordinates: this.new_geofence.coordinates
                    };
                    this.polygonsList.push(fence);
                    this.$emit('setGeoFence', this.polygonsList); //pass the geofence to the parent
                    this.new_geofence.coordinates = [];
                }
            }
            
            // if(this.polygonsList.length > 0) {
            //     //should remove
            //     this.polygonsList = []
            // }
            // else {
            //     //should add
            //     this.polygonsList.push(this.sample_polygon);
            // }
        },
        mapClick(event) { 
            if (this.user.userRoleId==5) {
                return;
            }
            if(this.geofencing_click) {
                var point = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                };
                this.new_geofence.coordinates.push(point);
            }
            else {
                this.new_geofence.coordinates = [];
                this.addDeliveryAddress({
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                });
            }
        },
        generateChipStyle(color) {
            this.$emit('setStationsList', this.markers);
            this.$emit('setGeoFence', this.polygonsList);
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`;
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        removeDeliveryAddress(index) {
            this.markers.splice(index,1);
        },
        driverMessageReceived(driver, message) {
            console.log(driver);
            //locate the driver first
            var user = driver.user;
            var existingDriver = this.allDrivers.find(d=>d.id === user);
            ///TODO extract the latitude, and longitude
            var _message = driver.message;
            var lat = parseFloat(driver.lat);
            var lng = parseFloat(driver.lng);
            if(existingDriver === undefined || existingDriver === null || existingDriver == "undefined") {
                
                var objDriver= this.entities['driver'].find(d=>d.id ==user); 
                
               this.allDrivers.push( {
                    id:user,
                    coordinate:{
                        lat:lat,
                        lng:lng
                    },
                    info: {
                        infoWinOpen:false,
                        waybillId:"objDriver.localizations[0].fullName", //todo -- fill with corresponding waybill id,
                        driverName:objDriver.localizations[0].fullName
                    }
                });
            }
            else {
                existingDriver.coordinate.lat = lat;
                existingDriver.coordinate.lng = lng;
            }
        },
        clickDriver(driver) {
            if(driver.info !== undefined) {
                driver.info.infoWindowOpen = !driver.info.infoWindowOpen;
            }
        },
        driverTrackingInfo(driver) {  
            if(driver.info !== undefined && driver.info.driverName!=null) { 
                    return `${driver.info.driverName} `;  
            } else if(driver.info!==undefined){
                driver.info.infoWindowOpen=false;
            }
        }
    }
}
</script>
<style scoped>
.autocomplete-field input {
    border: 1px solid green;
    height: 50px;
    padding-left: 15px;
    border-radius: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.draggable-div {
    padding: 16px 16px;
    border: 2px solid lightblue;
    margin: 16px 0;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
    display: none;
}
.v-application p {
    margin-bottom: 0 !important;
}
.station .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0 !important;
    display:none !important;
}
</style>